import { render, staticRenderFns } from "./RsaPazienteStatoRicoveriLettoListComponent.vue?vue&type=template&id=f072910a"
import script from "./RsaPazienteStatoRicoveriLettoListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteStatoRicoveriLettoListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports